'use client';

import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import styles from './SleepContributorModal.module.css';

export const SleepContributorModal = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();

  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="sleep-contributor-modal-heading"
    >
      <div className="container">
        <h4 id="sleep-contributor-modal-heading">
          {' '}
          {t('ring.bentoSleepSection.sleepContributorsCard.modal.head')}
        </h4>
        <h3>
          {t('ring.bentoSleepSection.sleepContributorsCard.modal.subHead')}
        </h3>
        <div className="modal-items">
          <div className="item">
            <p className="text-mid">
              {/* The Ultrahuman Ring AIR measures how you sleep by factoring in
                your performance with respect to{' '}
                <span className="bold">11+ contributors.</span> Some of these
                contributors{' '}
                <span className="thin">
                  Sleep Efficiency, Temperature, Restfulness, Total Sleep, HR
                  drop, Restoration Time among others.
                </span>{' '}
                Your performance with respect to each of these contributors is
                measured, and is classified as Good, Optimal or Needs attention. */}
              {t(
                'ring.bentoSleepSection.sleepContributorsCard.modal.cardA.desc',
              )}
            </p>
            {width > 992 ? (
              <div
                className="img-container"
                role="img"
                aria-label={t('sleepContributorModal.content.ariaLabel')}
              >
                <Image
                  src={
                    'web_v2/ring-buy/sleep/svg/flip/sleepContributorFlipA.svg'
                  }
                  fill
                  alt=""
                  className="sleep-index"
                  aria-hidden="true"
                />
              </div>
            ) : null}
          </div>
          {/* <div className="item">
              <p className="text-mid">
                How you do in each of these contributors directly impacts your
                overall Sleep Index performance. Thereby, to reach your goal of
                getting your best nights sleep, you ideally want to focus on
                each of your contributors and treat them as a checklist to get
                right. Essentially, the sleep contributors are our way of
                breaking down a good night’s sleep for you.
              </p>
              <div className="img-container">
                <Image
                  src={
                    'web_v2/ring-buy/sleep/svg/flip/sleepContributorFlipB.svg'
                  }
                  fill
                  alt="sleep-index"
                  className="sleep-index"
                />
              </div>
            </div> */}
        </div>
      </div>
    </div>
  );
};
